import { useCallback } from 'react';
import { useGenericSend } from '../useGenericSend';

import * as Types from './types';

export const useGetPlayerInfo = () => {
    const send = useGenericSend();

    return useCallback(async (
        request: Types.TGetPlayerInfoOptions,
        options?: { signal?: AbortSignal }
    ) => {
        const { data } = await send<Types.TGetPlayerInfoRequest, Types.TGetPlayerInfoResponseData>({
            ID: 31082,
            responses: [31083, 31084],
            requestType: 'marked',
            description: 'Get Player Info',
            ...request
        }, options);

        return data;
    }, [send]);
};
